var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{attrs:{"id":"price-board"}},[_c('b-row',[_c('b-col',[_c('show-price',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }